// @TODO: remove later if no need VIR staking claim
import React, { memo } from 'react'
import { Grid } from '@mui/material'
import { Link as MuiLink } from '@mui/material'
import { Trans } from 'react-i18next'

import CustomDialog from '../shared/customDialog/CustomDialog'
import { VIP_CLUB_ACCOUNT_URL } from '../../constants/app'
import Input from '../shared/inputs/Input'
import { STAKING_PROFILE_DISPATCH } from '../../store/reducers/staking'
import { transWithArgs } from '../../util/validation.helpers'
import CustomAlert from '../shared/CustomAlert/CustomAlert'

const ConnectAccountPopup = ({
  t,
  onClose,
  onSubmit,
  stakingProfile: { error, accountNumber, claimStakeProcessing },
  dispatchAction
}) => {
  const claimStakeError = error[STAKING_PROFILE_DISPATCH.CLAIM_STAKE]
  return (
    <CustomDialog
      isForm
      title={t('staking.connect-account-claim')}
      description={
        <Trans i18nKey='staking.connect-account-claim-desc'>
          <MuiLink
            href={VIP_CLUB_ACCOUNT_URL}
            target='_blank'
            color='inherit'
          />
        </Trans>
      }
      open
      onClose={onClose}
      cancelProps={{
        label: t('common.cancel'),
        autoWidth: true
      }}
      submitProps={{
        label: t('staking.connect'),
        disabled: claimStakeProcessing,
        autoWidth: true
      }}
      body={
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Input
              value={accountNumber}
              onChange={(value) =>
                dispatchAction(STAKING_PROFILE_DISPATCH.ACCOUNT_NUMBER, value)
              }
              placeholder={t('staking.vip-club-account-number')}
              hiddenLabel
              size='small'
              errorMessage={transWithArgs(
                t,
                error[STAKING_PROFILE_DISPATCH.ACCOUNT_NUMBER]
              )}
              inputProps={{
                maxLength: 36
              }}
            />
          </Grid>
          {(claimStakeProcessing || claimStakeError) && (
            <Grid item xs={12}>
              <CustomAlert
                info={claimStakeProcessing && t('home.transaction-processing')}
                error={claimStakeError && transWithArgs(t, claimStakeError)}
                onTimeOut={
                  claimStakeProcessing
                    ? () => {
                        dispatchAction(
                          STAKING_PROFILE_DISPATCH.CLAIM_STAKE_PROCESSING,
                          false
                        )
                      }
                    : null
                }
              />
            </Grid>
          )}
        </Grid>
      }
      onSubmit={onSubmit}
      t={t}
    />
  )
}

export default memo(ConnectAccountPopup)
